<template >
  <div class="ly-card message-manage">
    <div class="lf">
      <h3>模板</h3>
      <ul>
        <li
          v-for="item in sms_template_list"
          :class="curItem.id === item.id && 'active'"
          :key="item.id"
          @click="clickItem(item)"
        >{{item.name}}</li>
      </ul>
      <!-- <div class="btn-bottom">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openDg">新建模板</el-button>
      </div> -->
    </div>
    <div class="rg" v-if="curItem.id">
      <div class="content">
        <h3>模板内容：</h3>
        <p>{{curDetail.content}}</p>
      </div>
      <div class="bottom">
        <div>短信类型：{{curDetail.template_type_label}}</div>
        <div>申请说明：{{curDetail.template_remark}}</div>
        <div>审核状态：{{curDetail.audit_status_label}}</div>
        <div>创建时间：{{curDetail.create_time}}</div>
        <!-- <div>审核时间：{{curDetail.template_type_label}}</div> -->
        <!-- <el-button type="primary" @click="eidtTmp">编辑</el-button> -->
      </div>
    </div>
    <el-dialog title="添加模板" :visible.sync="dialogVisible" width="600px">
      <el-form size="small" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
        <el-form-item label="短信类型" prop="template_type">
          <el-select v-model="ruleForm.template_type" placeholder="请选择" class="width-full">
            <el-option
              v-for="item in smsType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请说明" prop="template_remark">
          <el-input v-model="ruleForm.template_remark" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <el-form-item label="模板名称" prop="name">
          <el-input v-model.trim="ruleForm.name" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <el-form-item label="模板内容" prop="content">
          <el-input
            ref="messageContent"
            type="textarea"
            :rows="6"
            v-model="ruleForm.content"
            placeholder="请输入模板内容（可点击下面的按钮添加相应变量）"
          ></el-input>
        </el-form-item>
        <el-form-item class="tags">
          <el-button type="primary" size="small" plain @click.native="insertValue">学员姓名</el-button>
          <el-button type="primary" size="small" plain>注册用户姓名</el-button>
          <el-button type="primary" size="small" plain>预约报名号</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTmp">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  Dialog, Form, FormItem, Input, Select, Option
} from 'element-ui';
import { message } from '@/api';

export default {
  name: 'structure',
  components: {
    ElInput: Input,
    ElDialog: Dialog,
    ElForm: Form,
    ElFormItem: FormItem,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      sms_template_list: [],
      name: '',
      curItem: {},
      curDetail: {},
      dialogVisible: false,
      smsType: [],
      ruleForm: {
        id: '',
        template_type: '',
        name: '',
        content: '',
        template_remark: ''
      },
      rules: {
        template_type: [{ required: true, message: '请选择模板类型', trigger: 'change' }],
        template_remark: [{ required: true, message: '请输入申请说明', trigger: 'blur' }],
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        content: [{ required: true, message: '请输入模板内容', trigger: 'blur' }]
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init(data) {
      message.querSmsTemplate().then(res => {
        if (res && res.data) {
          this.sms_template_list = res.data.sms_template_list;
          if (data && data.id) {
            this.clickItem(data);
          }
        }
      });
      message.smsTempType().then(res => {
        if (res && res.data) {
          this.smsType = Object.freeze(res.data.select_list);
        }
      });
    },
    async getDetail(item) {
      const res = await message.querSmsTemplateDetail({ id: item.id });
      if (res && res.data) {
        this.curDetail = res.data.sms_template_detail;
      }
    },
    clickItem(item) {
      this.curItem = item;
      this.getDetail(item);
    },
    async searchTmp() {
      const res = await message.searchSmsTemplate({ params: { name: this.name } });
      if (res) {
        console.log(res);
      }
    },
    openDg() {
      this.dialogVisible = true;
      this.ruleForm = {
        id: '',
        template_type: '',
        name: '',
        content: '',
        template_remark: ''
      };
    },
    eidtTmp() {
      this.openDg();
      this.ruleForm = { ...this.curDetail };
    },
    addTmp() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.ruleForm.id) {
            // 编辑
            message
              .editSmsTemplate({
                params: this.ruleForm
              })
              .then(res => {
                if (res && res.data) {
                  this.dialogVisible = false;
                  this.init({ id: res.data.new_sms_template.id });
                }
              });
            return;
          }
          message
            .addSmsTemplate({
              params: this.ruleForm
            })
            .then(res => {
              if (res && res.data) {
                this.dialogVisible = false;
                this.$message.success(res.msg || '添加模板成功！');
                this.init({ id: res.data.sms_template.id });
              }
            });
        }
      });
    },
    insertValue() {
      const el = this.$refs.messageContent.$refs.textarea;
      // eslint-disable-next-line no-template-curly-in-string
      this.insertAfterText(el, '${name}');
      this.ruleForm.content = el.value;
    },
    insertAfterText(textDom, value) {
      const tmp = textDom;
      let selectRange;
      if (document.selection) {
        // IE Support
        textDom.focus();
        selectRange = document.selection.createRange();
        selectRange.text = value;
        textDom.focus();
      } else if (textDom.selectionStart || Number(textDom.selectionStart) === 0) {
        // Firefox support
        const startPos = textDom.selectionStart;
        const endPos = textDom.selectionEnd;
        const { scrollTop } = textDom;
        tmp.value = `${textDom.value.substring(0, startPos)}${value}${textDom.value.substring(
          endPos,
          textDom.value.length
        )}`;
        tmp.focus();
        tmp.selectionStart = startPos + value.length;
        tmp.selectionEnd = startPos + value.length;
        tmp.scrollTop = scrollTop;
      } else {
        tmp.value += value;
        textDom.focus();
      }
    }
  }
};
</script>
<style lang="less">
.message-manage {
  display: flex;
  height: calc(100vh - @navBarTopHeight - @navBarTagsHeight - 10px);
  overflow: auto;
  .lf {
    width: 220px;
    height: 100%;
    background: #fff;
    border-right: 1px solid #ccc;
    overflow: auto;
    position: relative;
    padding-bottom: 40px;
    padding-right: 10px;
    h3 {
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
    }
    .btn-bottom {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      text-align: center;
    }
    ul {
      padding-left: 10px;
      li {
        list-style: none;
        display: flex;
        cursor: pointer;
        font-size: 15px;
        padding: 10px 5px;
        align-items: center;
        border-bottom: 1px solid #ccc;
        &.active {
          color: #fff;
          background: @main-blue;
          border-color: @main-blue;
        }
      }
    }
  }
  .rg {
    flex: 1;
    margin-left: 10px;
    .content {
      border-bottom: 1px solid #ccc;
      padding: 10px 0;
      p {
        text-indent: 30px;
      }
    }
    .show-list .info {
      ul {
        li {
          list-style: none;
          margin: 20px 0;
          > .title {
            display: inline-block;
            min-width: 100px;
            font-size: 16px;
          }
          .content {
            color: #333;
            font-size: 14px;
          }
        }
      }
    }
    .input-flex {
      display: flex;
      .el-input {
        margin-right: 20px;
        width: 202px;
      }
    }
    .bottom > div {
      margin: 20px 0;
    }
  }
  .tags {
    .el-button {
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>
